import { useNavigate } from "react-router-dom";

const NewReleaseAvailable = () => {
  const navigate = useNavigate()

  return (
    <div className="p-2 bg-valid fixed w-full text-sm flex items-center justify-center gap-3 z-50">
      <p className="text-black-900">
        Nova atualização disponível do sistema.{' '}
          <span
            className="underline font-bold cursor-pointer"
            onClick={() => navigate(0)}
          >
            Clique aqui
          </span>
        {' '}para atualizar.
      </p>
    </div>
  );
};

export default NewReleaseAvailable;